import { render, staticRenderFns } from "./AccountFriendProfile.vue?vue&type=template&id=e62c1364&lang=pug&"
import script from "./AccountFriendProfile.vue?vue&type=script&lang=js&"
export * from "./AccountFriendProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountFriendProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports